import { trpcApi } from '@bitbot/api';
import { useToken } from './token';
import { Notify } from '@bitbot/ui-design';
import { useCallback, useState } from 'react';
import { useEmail } from './email';
import { debounce } from 'lodash';
import { useGlobalValueStore } from '../trade/common';
import { useWallets } from '../wallet';

export const useLoginTrade = () => {
  const {
    email,
    setEmail,
    emailCode,
    setEmailCode,
    countDown,
    setCountDown,
    hasSent,
    setHasSent,
    authCode,
    setAuthCode,
    status,
    isSendingCode,
    setIsSendingCode,
    emailCodeError,
    otpCodeError,
    setEmailCodeError,
    setOtpCodeError,
  } = useEmail();

  const { setWalletsInfo } = useWallets();

  const { setTradeToken } = useToken();
  const {
    setShowCreateWalletAndLoginDialog,
    setShowLoginDialog,
    setRecentWallets,
    setShowBalance,
  } = useGlobalValueStore();
  const [isLoading, setIsLoading] = useState(false);
  const loginTrade = useCallback(
    debounce(() => {
      if (status.status) {
        setIsLoading(true);
        trpcApi.wallet.getWallets
          .query({
            needLogin: true,
            email,
            otp: authCode,
            code: emailCode,
          })
          .then(data => {
            setTradeToken(data.token!);
            setWalletsInfo(data);
            setRecentWallets([]);
            setShowBalance(true);
            setShowCreateWalletAndLoginDialog(false);
            setTimeout(() => {
              setShowLoginDialog(false);
            });
          })
          .catch(e => {
            if (e.message === 'Invalid OTP') {
              setOtpCodeError(true);
            } else if (e.message === 'Invalid or expired code') {
              setEmailCodeError(true);
            } else {
              Notify.error(e.message);
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }, 300),
    [email, emailCode, authCode, status],
  );

  const sendCode = useCallback(
    debounce(() => {
      if (status.emailStatus) {
        setIsSendingCode(true);
        trpcApi.user.sendCodeEmail
          .query({ email })
          .then(data => {
            if (data) {
              setHasSent(true);
            } else {
              Notify.error('Send code failed, please try again later');
            }
          })
          .catch(e => {
            Notify.error(e.message);
          })
          .finally(() => {
            setIsSendingCode(false);
          });
      }
    }, 300),
    [email, status],
  );

  return {
    email,
    setEmail,
    emailCode,
    setEmailCode,
    countDown,
    setCountDown,
    hasSent,
    setHasSent,
    authCode,
    setAuthCode,
    status,
    loginTrade,
    sendCode,
    isSendingCode,
    emailCodeError,
    otpCodeError,
    isLoading,
  };
};
